import React from 'react'

import { Description, Title, ListItemLabel, Subtitle } from 'components/ui/list-item-label'
import { RadioInputElement } from 'components/ui/radio'

import { Steps } from '.'

type Option = {
  readonly id: keyof Steps;
  readonly title: string;
  readonly subtitle: string;
}

type Props = {
  readonly selectedType: keyof Steps | undefined;
  readonly setSelectedType: React.Dispatch<keyof Steps>;
}

export const SelectPageType = (props: Props) => {

  const {
    selectedType,
    setSelectedType,
  } = props

  const options: ReadonlyArray<Option> = [
    {
      id: 'createContentPage' as const,
      title: 'Content Page',
      subtitle: 'Create a content page with image and text',
    },
    {
      id: 'createImagePage' as const,
      title: 'Image Page',
      subtitle: 'Create a page with a single image',
    },
    {
      id: 'createHTMLPage' as const,
      title: 'HTML Web Page',
      subtitle: 'Create a page by directly putting in the HTML code',
    },
    {
      id: 'createURLPage' as const,
      title: 'URL Web Page',
      subtitle: 'Create a page from an external URL',
    },
    {
      id: 'createAppPage' as const,
      title: 'App Page',
      subtitle: 'A special page that is built into the app itself eg. Settings',
    },
    {
      id: 'createDeepDivePage' as const,
      title: 'Deep Dive Page',
      subtitle: 'Create a page for Deep Dive links',
    },
  ]

  return (
    <>
      {options.map(option => (
        <ListItemLabel key={option.id}>
          <RadioInputElement
            checked={selectedType === option.id}
            onChange={e => setSelectedType(e.target.name as keyof Steps)}
            name={option.id}
              />
          <Description>
            <Title>{option.title}</Title>
            <Subtitle>{option.subtitle}</Subtitle>
          </Description>
        </ListItemLabel>
      ))}
    </>
  )
}
